import {
  DashboardWorkflowsListDocument,
  type DashboardWorkflowsListQuery,
  type DashboardWorkflowsListQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_WORKFLOWS_LIST_LOADER = async () => {
  const { data } = await client.query<
    DashboardWorkflowsListQuery,
    DashboardWorkflowsListQueryVariables
  >({
    query: DashboardWorkflowsListDocument,
    fetchPolicy: "network-only",
  });

  return data;
};
